"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utilities_1 = require("../../utilities");
const FoodCard_1 = __importDefault(require("../modules/FoodCard")); // Import the FoodCard component
const material_1 = require("@mui/material");
const colors_1 = require("@mui/material/colors");
require("../../utilities.css");
require("./YourPosts.css");
// TO DO: IMPORT POSTS FROM FEED OR DATABASE THAT BELONG TO USER
const YourPosts = (props) => {
    const [user, setUser] = (0, react_1.useState)();
    // const [userPosts, setUserPosts] = useState([]); // State to store the user's posts
    const [userPosts, setUserPosts] = (0, react_1.useState)([]); // Specify the type
    (0, react_1.useEffect)(() => {
        document.title = "Your Posts";
        // Fetch user information
        (0, utilities_1.get)("/api/whoami").then((userObj) => setUser(userObj));
        console.log("user is", user === null || user === void 0 ? void 0 : user.name);
        (0, utilities_1.get)(`/api/user/me/posts`).then((posts) => setUserPosts(posts));
        // console.log("userPosts is", userPosts[0]);
    }, []);
    if (!user) {
        return react_1.default.createElement("div", null, " Loading! ");
    }
    const renderAvatar = (user) => {
        // Handle Google avatars
        if (user.picture) {
            return react_1.default.createElement(material_1.Avatar, { alt: "Avatar", src: user.picture });
        }
        else {
            // Default avatar or placeholder if login type is unknown
            return (react_1.default.createElement(material_1.Avatar, { sx: { bgcolor: colors_1.red[500] }, "aria-label": "recipe" }, user.name.at(0)));
        }
    };
    const getRandomPersonalMessage = (tier) => {
        const messages = {
            lessThan5: [
                "You're a food waste warrior in the making! Keep those posts coming ;)",
                "Every post means one less 'unsubscribe pls🥺' making it to free-foods xD (claims unverified...)",
            ],
            between5And9: [
                "Thanks for being a food waste warrior! Every post makes a difference :)",
                "You're a super poster! Your foodie adventures are making waves.",
            ],
            between10And24: [
                "You're a free food fiend! Your posts are spreading true culinary joy :P",
                "Feaster of freebies! Poster of the delicious!",
            ],
            between25And49: [
                "You're a foodie legend! Your posts have reached legendary status.",
                "Legendary muncher! Your posts are the stuff of food folklore.",
            ],
            fiftyOrMore: [
                "You're a true Unsubscribe champion! Your posts have set the bar high.",
                "Champion of munching! Your posts are a *feast* for the eyes.",
            ],
        };
        const randomIndex = Math.floor(Math.random() * 2); // Randomly choose between two messages
        return messages[tier][randomIndex];
    };
    const getPersonalMessage = () => {
        const numberOfPosts = userPosts.length;
        if (numberOfPosts < 5) {
            return getRandomPersonalMessage("lessThan5");
        }
        else if (numberOfPosts < 10) {
            return getRandomPersonalMessage("between5And9");
        }
        else if (numberOfPosts < 25) {
            return getRandomPersonalMessage("between10And24");
        }
        else if (numberOfPosts < 50) {
            return getRandomPersonalMessage("between25And49");
        }
        else {
            return getRandomPersonalMessage("fiftyOrMore");
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "YourPosts-container" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h1", { className: "YourPosts-name u-flex u-flex-alignCenter" },
                    renderAvatar(user),
                    " \u00A0",
                    user.name),
                react_1.default.createElement("p", { className: "YourPosts-congratulatory-message u-flex u-textCenter u-flex-alignCenter" }, getPersonalMessage())),
            react_1.default.createElement("hr", { className: "YourPosts-linejj" }),
            react_1.default.createElement("div", { className: "YourPosts-feed u-flex u-flex-alignCenter" },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 2.5 }, userPosts.map((post) => (react_1.default.createElement(material_1.Grid, { item: true, key: post._id, xs: 12, sm: 6, md: 3 },
                    react_1.default.createElement(FoodCard_1.default, Object.assign({}, post))))))))));
};
exports.default = YourPosts;
